import { useMemo } from 'react';
import dayjs from 'dayjs';

import { useSitrepV2 } from 'components/DisasterGPT/hooks/useSitrepsV2';
import { useAllIncidents } from 'components/IAP/hooks/incidentHooks';
import { useAors } from 'hooks/useAors';

const useSitrepCardContentData = (sitrepId: UUID) => {
  const {
    data: sitrepData,
    isLoading: sectionsLoading,
    refetch,
    dataUpdatedAt,
  } = useSitrepV2(sitrepId);

  const { data: aors = [] } = useAors();
  const { data: incidents = [] } = useAllIncidents();

  const aorName = useMemo(() => {
    const aor = aors.find((currentAor) => currentAor.id === sitrepData?.aor_id);
    return aor?.name ?? null;
  }, [aors, sitrepData?.aor_id]);

  const incidentName = useMemo(() => {
    const incident = incidents.find(
      (currentIncident) => currentIncident.id === sitrepData?.incident_id
    );
    return incident?.name ?? null;
  }, [incidents, sitrepData?.incident_id]);

  const refreshedAt = useMemo(
    () =>
      dataUpdatedAt ? dayjs(dataUpdatedAt).format('MM/DD/YYYY HH:mm') : null,
    [dataUpdatedAt]
  );

  return {
    sitrepData,
    sectionsLoading,
    refetch,
    aorName,
    incidentName,
    refreshedAt,
  } as const;
};

export default useSitrepCardContentData;
